import React from 'react';

import type { CompletedCalculationTactic } from '../../overmind/calculation';
import type { ShortCircuitSummary } from '../../overmind/calculation/derived-state/shortCircuitSummary';
import { LvShortCircuitSummaryCalculationResults } from '../LowVoltageCalculation/ShortCircuitSummaryCalculationResults/LvShortCircuitSummaryCalculationResults';
import { MvShortCircuitSummaryCalculationResults } from '../MediumVoltageCalculation/ShortCircuitSummaryCalculationResults/MvShortCircuitSummaryCalculationResults';

type ShortCircuitResultsProps = {
  shortCircuitScenarios: CompletedCalculationTactic['calculationSetResult']['calculationScenarios']['shortCircuit'];
  shortCircuitSummary: ShortCircuitSummary;
};

export function ShortCircuitResults(props: ShortCircuitResultsProps) {
  if (props.shortCircuitSummary.type === 'MediumVoltage') {
    return (
      <MvShortCircuitSummaryCalculationResults
        shortCircuitSummary={props.shortCircuitSummary.value}
      />
    );
  }
  if (props.shortCircuitSummary.type === 'LowVoltage') {
    return (
      <LvShortCircuitSummaryCalculationResults
        shortCircuitSummary={props.shortCircuitSummary.value}
      />
    );
  }
  return null;
}
